import React, { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,

  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
} from '@mui/material';
import { DriverCheckin } from '../types'; // Assumindo que 'types' está no mesmo nível ou acessível

interface ModalCancelCheckinProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  driver: DriverCheckin;
  cancelReasons: string[];
}

const ModalCancelCheckin: React.FC<ModalCancelCheckinProps> = ({
  open,
  onClose,
  onConfirm,
  driver,
  cancelReasons,
}) => {
  const [selectedCancelReason, setSelectedCancelReason] = useState('');
  const [otherCancelReason, setOtherCancelReason] = useState('');

  const handleConfirm = () => {
    if (selectedCancelReason === 'Outros' && otherCancelReason.trim() === '') {
      alert('Por favor, digite o motivo do cancelamento.');
      return;
    }
    const reason = selectedCancelReason === 'Outros' ? otherCancelReason : selectedCancelReason;
    onConfirm(reason);
    setSelectedCancelReason('');
    setOtherCancelReason('');

  };


  const handleClose = () => {

    onClose();
    setSelectedCancelReason('');
    setOtherCancelReason('');
  };

  const isConfirmDisabled = !selectedCancelReason || (selectedCancelReason === 'Outros' && otherCancelReason.trim() === '');


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-describedby="cancel-dialog-description"
    >
      <DialogTitle id="cancel-dialog-title">{"Confirmar Cancelamento"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="cancel-dialog-description" sx={{ mb: 2 }}>
          Selecione o motivo do cancelamento para {driver.driver_name} (Placa: {driver.license_plate}):

        </DialogContentText>
        <FormControl fullWidth sx={{ mb: 2 }}>

          <InputLabel id="cancel-reason-select-label">Motivo</InputLabel>

          <Select
            labelId="cancel-reason-select-label"
            id="cancel-reason-select"
            value={selectedCancelReason}
            label="Motivo"
            onChange={(e) => setSelectedCancelReason(e.target.value as string)}
          >
            {cancelReasons.map((reason) => (
              <MenuItem key={reason} value={reason}>{reason}</MenuItem>

            ))}
          </Select>
        </FormControl>
        {selectedCancelReason === 'Outros' && (
          <TextField

            autoFocus
            margin="dense"
            id="other-reason"
            label="Especificar Outro Motivo"
            type="text"
            fullWidth
            required
            variant="outlined"
            value={otherCancelReason}
            onChange={(e) => setOtherCancelReason(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Voltar</Button>
        <Button
          onClick={handleConfirm}
          disabled={isConfirmDisabled}

          color="error"
        >
          Confirmar Cancelamento
        </Button>
      </DialogActions>
    </Dialog>

  );
};

export default ModalCancelCheckin;
